import { create } from 'zustand'

type ToastType = 'success' | 'error' | 'info'
type Toast = { id: string; type: ToastType; message: string }

type ToastStore = {
  toasts: Toast[]
  _add: (type: ToastType, message: string) => void
  dismiss: (id: string) => void
}

export const useToastStore = create<ToastStore>((set) => ({
  toasts: [],
  _add: (type, message) => {
    const id = Math.random().toString(36).slice(2, 9)
    set((s) => ({ toasts: [...s.toasts.slice(-4), { id, type, message }] }))
    setTimeout(
      () => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
      type === 'error' ? 5000 : 3000,
    )
  },
  dismiss: (id) => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}))

export const toast = {
  success: (msg: string) => useToastStore.getState()._add('success', msg),
  error:   (msg: string) => useToastStore.getState()._add('error',   msg),
  info:    (msg: string) => useToastStore.getState()._add('info',    msg),
}
